import React from "react";
import "../Hero/CareerHero.css";

export default function CareerHero() {
  return (
    <section className="careers-hero">
      <div className="careers-hero__content">
        <div className="careers-hero__label">On recrute</div>
        <h1 className="careers-hero__title">
          Rejoignez notre equipe<br />
          <span>a Abidjan</span>
        </h1>
        <p className="careers-hero__subtitle">
          Construisons ensemble les solutions digitales de demain pour les entreprises ivoiriennes.
          Equipe jeune, projets concrets, ambiance bienveillante.
        </p>
        <div className="careers-hero__actions">
          <a href="#offres" className="careers-hero__cta">
            Voir les offres
          </a>
          <a
            href="mailto:contact@nxs-solutions.com"
            className="careers-hero__wa"
          >
            Candidature spontanee
          </a>
        </div>
      </div>
    </section>
  );
}
